import gqlTagGira from 'graphql-tag';

/**
 * View items query
 *
 * IssueLinks are part of the top level top level
 * */

export const TIMELINE_VIEW_ITEM_FRAGMENT = gqlTagGira`
    fragment JWMTimelineViewItem on JiraWorkManagementViewItem {
        fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
            id
            fieldId
            aliasFieldId
            type
            ... on JiraSingleLineTextField {
                text
            }
            ... on JiraStatusField {
                status {
                    name
                    statusId
                    statusCategory {
                        statusCategoryId
                    }
                }
            }
            ... on JiraIssueTypeField {
                issueType {
                    issueTypeId
                    name
                    avatar {
                        medium
                    }
                    hierarchy {
                        level
                    }
                }
            }
            ... on JiraSingleSelectUserPickerField {
                user {
                    accountId
                    picture
                    name
                }
            }
            ... on JiraDatePickerField {
                date
            }
            ... on JiraParentIssueField {
                parentIssue {
                    issueId
                    key
                    rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") {
						... on JiraSingleLineTextField {
							text
						}
					}
                }
            }
        }
    }
`;

// this query is the main list that will appear in the view
export const TIMELINE_VIEW_ITEMS_QUERY = gqlTagGira`
    query JWMTimelineViewItems ($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String) {
        jira {
            list: jwmViewItems(
                cloudId: $cloudId,
                jql: $jql,
                first: $first,
                after: $after,
                ) @connection (key: "timelineList", filter:["jql"]) {
                ... on JiraWorkManagementViewItemConnection {
                    edges {
                        node {
                            id
                            issueId
                            childSummary(includeDone: $includeDoneItems) {
                                hasChildren
                            }
                            issueLinks(first: 10) {
                                edges {
                                    node {
                                        issue {
                                            issueId
                                        }
                                        issueLinkId
                                        relationName
                                        direction
                                    }
                                }
                            }
                            ... JWMTimelineViewItem
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        }
    }
    ${TIMELINE_VIEW_ITEM_FRAGMENT}
`;
